<div class="custom-tooltip-wrapper d-flex" [ngClass]="getClassPosition()" (mouseenter)="triggerShow('mouseenter')" (mouseleave)="triggerShow('mouseleave')">
  <div class="d-flex justify-content-center align-items-center button-wrapper"
  [ngClass]="{'button-click': eventTrigger == 'CLICK'}"
  (click)="triggerShow('click')" #btnWrapper>
    <span #ref>
      <ng-content select="[custom-tooltip-button]"></ng-content>
    </span>
    <ng-container *ngIf="!ref.innerHTML.trim();">
      <ng-container *ngTemplateOutlet="btnContent"></ng-container>
    </ng-container>
  </div>
  <div class="custom-tooltip-content-wrapper" *ngIf="viewMore" [ngStyle]="getOffsetStyle()">
    <div class="custom-tooltip-content">
      <ng-content select="[custom-tooltip-content]"></ng-content>
    </div>
  </div>
</div>

<ng-template #btnContent>
  <span class="view-more d-flex flex-column align-items-center">
    <mat-icon class="icon pointer exclamation-mark" svgIcon="exclamation-mark"></mat-icon>
  </span>
</ng-template>
